"use client";

import { useQuery } from "@apollo/client/react";

import { gql } from "graphql-tag";
import { useAuthenticatedContext } from "@portal/app/_components/context/AuthenticatedContext";
import { useResumableSchoolEnrollments } from "@portal/app/_components/context/useResumableSchoolEnrollments";
import { GetCurrentDashboardEnrollmentItemsDocument } from "./generated";
import { selectCurrentDashboardResumables } from "../dashboardProgramSections";

void gql`
  query getCurrentDashboardEnrollmentItems($customerId: ID!) {
    currentEnrollmentItemsOfType(customerId: $customerId, type: SCHOOL) {
      id
      status
      programId
    }
  }
`;

export const useCurrentDashboardResumables = ({ skip = false }: { skip?: boolean } = {}) => {
  const { customerId } = useAuthenticatedContext();
  const shouldSkip = skip || !customerId;
  const resumableQuery = useResumableSchoolEnrollments({ skip: shouldSkip });
  const currentQuery = useQuery(GetCurrentDashboardEnrollmentItemsDocument, {
    variables: { customerId: customerId! },
    skip: shouldSkip,
  });
  const loading = resumableQuery.loading || currentQuery.loading;
  const error = resumableQuery.error ?? currentQuery.error;

  return {
    loading,
    error,
    enrollments:
      shouldSkip || loading || error
        ? undefined
        : selectCurrentDashboardResumables(
            resumableQuery.enrollments ?? [],
            currentQuery.data?.currentEnrollmentItemsOfType ?? []
          ),
  };
};
